import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import { Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, useTheme } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import GroupIcon from '@mui/icons-material/Group';
// import logoImg from '../../assets/img/Logo-Amarelo.png';


const SidebarAdmin = ({ openSidebar, handleSidebarClose, drawerWidth, DrawerHeader }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const SidebarDrawer = styled(Drawer)({
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
        },
    });


    // const Title = styled(Typography)({
    //     fontSize: '1.5rem',
    //     fontWeight: '600',
    //     color: '#333'
    // });

    const lastPart = window.location.href.split("/")[4];

    return (
        <SidebarDrawer
            variant="persistent"
            anchor="left"
            open={openSidebar}
        >
            <DrawerHeader >
                {/* <Title component='h4'>Fourbet</Title> */}
                <IconButton onClick={handleSidebarClose}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
                <ListItem disablePadding>
                    <Typography variant="span" sx={{ marginLeft: '8px', fontWeight: '700' }}>
                        Gestão
                    </Typography>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/admin')}
                        selected={lastPart === 'dashboard'}
                    >
                        <ListItemIcon>
                            <GroupIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Usuários'} primaryTypographyProps={{ fontWeight: lastPart === 'dashboard' ? '600' : '400' }} />
                    </ListItemButton>
                </ListItem>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/')}
                    >
                        <ListItemText primary={'Sair'} />
                    </ListItemButton>
                </ListItem>

                {/* <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/admin/eventos-personalizados')}
                        selected={lastPart === 'eventos-personalizados'}
                    >
                        <ListItemText primary={'Eventos Personalizados'} primaryTypographyProps={{ fontWeight: lastPart === 'eventos-personalizados' ? '600' : '400' }} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/admin/festa-pontos')}
                        selected={lastPart === 'festa-pontos'}
                    >
                        <ListItemText primary={'Festa dos pontos'} primaryTypographyProps={{ fontWeight: lastPart === 'festa-pontos' ? '600' : '400' }} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/admin/resultados')}
                        selected={lastPart === 'resultados'}
                    >
                        <ListItemText primary={'Resultados'} primaryTypographyProps={{ fontWeight: lastPart === 'resultados' ? '600' : '400' }} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/admin/supervisao')}
                        selected={lastPart === 'supervisao'}
                    >
                        <ListItemText primary={'Supervisao'} primaryTypographyProps={{ fontWeight: lastPart === 'supervisao' ? '600' : '400' }} />
                    </ListItemButton>
                </ListItem> */}

            </List>
        </SidebarDrawer >
    )
}
export default SidebarAdmin;